var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedirectDoorInDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 270,
    viewBox: "0 0 1200 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 238.432H1200",
    stroke: "#50E3C0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 32.4309,
    width: 150,
    height: 206,
    rx: 10,
    fill: "#C1FBED",
    stroke: "#50E3C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.112 11.2294C567.882 9.88344 562 14.6305 562 21.0039V127.613V142.613V249.221C562 255.595 567.882 260.342 574.112 258.996L667.112 238.902C671.715 237.908 675 233.837 675 229.128V142.613V127.613V41.0975C675 36.3884 671.715 32.3175 667.112 31.323L574.112 11.2294Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M574.112 11.2294L573.901 12.2069L574.112 11.2294ZM574.112 258.996L573.901 258.018H573.901L574.112 258.996ZM667.112 238.902L667.323 239.88L667.112 238.902ZM667.112 31.323L667.323 30.3456L667.112 31.323ZM563 21.0039C563 15.2678 568.294 10.9955 573.901 12.2069L574.323 10.252C567.47 8.7714 561 13.9931 561 21.0039H563ZM563 127.613V21.0039H561V127.613H563ZM561 127.613V142.613H563V127.613H561ZM561 142.613V249.221H563V142.613H561ZM561 249.221C561 256.232 567.47 261.454 574.323 259.973L573.901 258.018C568.294 259.23 563 254.957 563 249.221H561ZM574.323 259.973L667.323 239.88L666.901 237.925L573.901 258.018L574.323 259.973ZM667.323 239.88C672.386 238.786 676 234.308 676 229.128H674C674 233.366 671.043 237.03 666.901 237.925L667.323 239.88ZM676 229.128V142.613H674V229.128H676ZM676 142.613V127.613H674V142.613H676ZM674 41.0975V127.613H676V41.0975H674ZM666.901 32.3004C671.043 33.1955 674 36.8593 674 41.0975H676C676 35.9175 672.386 31.4395 667.323 30.3456L666.901 32.3004ZM573.901 12.2069L666.901 32.3004L667.323 30.3456L574.323 10.252L573.901 12.2069Z",
    fill: "#50E3C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M583.5 135.431C583.5 139.14 581.156 141.931 578.5 141.931C575.844 141.931 573.5 139.14 573.5 135.431C573.5 131.722 575.844 128.931 578.5 128.931C581.156 128.931 583.5 131.722 583.5 135.431Z",
    fill: "#50E3C0",
    stroke: "#50E3C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M581 133.749C581 132.528 582.085 131.592 583.293 131.771L591.293 132.956C592.274 133.101 593 133.943 593 134.934V136.181C593 137.191 592.247 138.042 591.245 138.166L583.245 139.154C582.052 139.301 581 138.371 581 137.169V133.749Z",
    fill: "#50E3C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 239.432,
    width: 1.99999,
    height: 130,
    transform: "rotate(-90 0 239.432)",
    fill: "url(#paint0_linear_1509_20215)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.99999,
    height: 130,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 1200 239.432)",
    fill: "url(#paint1_linear_1509_20215)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_20215",
    x1: 0.999997,
    y1: 239.432,
    x2: 0.999997,
    y2: 369.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1509_20215",
    x1: 0.999997,
    y1: 0,
    x2: 0.999997,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectDoorInDesktop);
export default __webpack_public_path__ + "static/media/RedirectDoorInDesktop.783fcba3f85d2448e8ebf909a440e6f0.svg";
export { ForwardRef as ReactComponent };